import { STATUS_COLORS } from '../utils/reportConstants';

// Get franchisee ID for current user context
export const getFranchiseeId = (userProfile) => {
  if (userProfile?.role === 'franchisee') {
    return userProfile.id;
  } else if (userProfile?.role === 'technician' && (userProfile?.franchiseeId || userProfile?.assignedFranchiseeId)) {
    return userProfile.franchiseeId || userProfile.assignedFranchiseeId;
  } else if (userProfile?.role === 'admin') {
    return userProfile.id;
  }
  return null;
};

// Get status badge color class
export const getStatusBadgeColor = (status) => {
  return STATUS_COLORS[status] || STATUS_COLORS.default;
};

// Format currency amount
export const formatCurrency = (amount) => {
  if (!amount) return '£0.00';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(amount);
};

// Format date string
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};